// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__d40ku","name":"ConsentHeader_name__24j-w","birthday":"ConsentHeader_birthday__2uoRS","skeleton":"ConsentHeader_skeleton__kMMhv"};